import React from 'react';
import Flexbox from 'flexbox-react';
import { css } from 'emotion';
import { getAnchorStyle, colorGreen } from 'styles/base';

import ProcessField from 'components/core/fields/ProcessField';
import InfoMessages from 'components/core/help/InfoMessages';
import InfoBoxLabel from 'components/core/InfoBoxLabel';
import RIEInput from 'components/core/editable/RIEInput';

const anchorStyle = css`
    margin: 2px 5px 0 5px;
    ${getAnchorStyle(colorGreen)}
`;

export default class ProcessCodeUrlField extends ProcessField {

    static propTypes = Object.assign({
    }, ProcessField.propTypes);

    static defaultProps = Object.assign({
    }, ProcessField.defaultProps);

    render() {
        let codeUrl = '';
        if (this.props.process.ui_state && this.props.process.ui_state.code_url) {
            codeUrl = this.props.process.ui_state.code_url;
        }

        let externalLink = null;
        if (codeUrl) {
            externalLink = (
                <a className={anchorStyle} href={codeUrl} target="_blank" rel="noopener noreferrer">
                    <i className="fa fa-external-link" aria-hidden="true"/>
                </a>
            );
        }

        return (
            <div>
                <Flexbox flexDirection="row" alignItems="flex-start" className={this.props.className}>
                    <InfoBoxLabel
                        label="Code Repository"
                        message={InfoMessages.codeUrl}
                    />
                    {externalLink}
                    <RIEInput
                        value={codeUrl}
                        change={this.onFieldUpdated}
                        fieldPath={['ui_state', 'code_url']}
                        isDisabled={!this.props.hasWritePermissions}
                        processId={this.props.process.name}
                        processErrors={this.props.processErrors}
                        componentView={this.props.forceFormDisplay}
                    />
                </Flexbox>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/core/fields/ProcessCodeUrlField.js